import { Link } from 'react-router-dom';
import { categories } from '@/mocks/dramas';

export default function Footer() {
  return (
    <footer className="bg-background-950 border-t border-background-200/30">
      <div className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-fill text-2xl text-primary-500"></i>
              </div>
              <span className="text-xl font-heading text-foreground-100 group-hover:text-primary-400 transition-colors">
                桃子影院
              </span>
            </Link>
            <p className="text-foreground-600 text-sm leading-relaxed">
              桃子影院提供海量电视剧全集在线观看服务，国产剧、韩剧、美剧、日剧、动漫、综艺全覆盖。
              高清超清蓝光4K画质，永久免费，无需缓冲，畅享极致观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-200 font-heading text-base mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#hot" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">
                  热播推荐
                </a>
              </li>
              <li>
                <a href="#new" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">
                  最新更新
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-200 font-heading text-base mb-4">剧集分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/category/${cat.key}`}
                    className="text-foreground-500 hover:text-primary-400 text-sm transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-200 font-heading text-base mb-4">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-primary-500 mt-0.5 shrink-0">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                <span className="text-foreground-500 text-sm">contact@taozitv.com</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-primary-500 mt-0.5 shrink-0">
                  <i className="ri-customer-service-line text-sm"></i>
                </div>
                <span className="text-foreground-500 text-sm">在线客服：7×24小时</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-primary-500 mt-0.5 shrink-0">
                  <i className="ri-shield-check-line text-sm"></i>
                </div>
                <span className="text-foreground-500 text-sm">内容安全举报</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-700 text-xs">
            &copy; {new Date().getFullYear()} 桃子影院 Taozitv.com — 永久免费在线观看电视剧全集
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-600 hover:text-primary-400 text-xs transition-colors whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-foreground-600 hover:text-primary-400 text-xs transition-colors whitespace-nowrap" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-foreground-600 hover:text-primary-400 text-xs transition-colors whitespace-nowrap" rel="nofollow">
              DMCA
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}